import { Group } from "@lib/store";
import { useTranslation } from "react-i18next";
import { Icon } from "@atoms";
import { AvatarStack, GroupAvatar } from "@molecules";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

const now = new Date();

export const GroupItem = ({ group }: { group: Group }) => {
  const { t } = useTranslation();
  const dateKey = format(now, "yyyy-MM-dd");
  const navigate = useNavigate();

  const acceptedMembers = group.members.filter(member => member.status === "Accepted");

  return (
    <button
      onClick={() => {
        navigate(`/connect/groups/${group.id}`);
      }}
      className={`grid grid-cols-[auto_1fr_auto_auto] gap-x-4 items-center w-full px-4 sm:px-6 md:px-8 py-4 text-left hover:bg-mapiq-black-50 transition-colors`}>
      <GroupAvatar
        size="large"
        group={group}
        className="shadow-mapiq-small shrink-0"
      />

      <div className="grid">
        <p className="font-semibold text-mapiq-black-800* truncate">{group.name}</p>

        <p className=" text-mapiq-black-500 truncate">{t("groups:Member", { count: acceptedMembers.length })}</p>
      </div>

      <AvatarStack
        users={acceptedMembers.map(({ user }) => user)}
        max={3}
        overlap
        date={dateKey}
      />
      <Icon
        icon="caretRight"
        className="ml-auto self-center size-5"
      />
    </button>
  );
};
